import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import BuildIcon from '@mui/icons-material/Build';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const steps = [
  { icon: <SearchIcon fontSize="large" />, title: 'Inspection', text: 'We perform a thorough system check: airflow, refrigerant levels, combustion safety, and controls.' },
  { icon: <BuildIcon fontSize="large" />, title: 'Diagnosis', text: 'We explain what we found, what it means, and the risks of delaying service.' },
  { icon: <AttachMoneyIcon fontSize="large" />, title: 'Quote', text: 'Clear, upfront pricing with options so you can choose the best path.' },
  { icon: <CheckCircleIcon fontSize="large" />, title: 'Repair', text: 'We complete work to code, test performance, and clean the workspace.' }
];

export default function ProcessSteps() {
  return (
    <Grid container spacing={3}>
      {steps.map((s) => (
        <Grid item xs={12} md={3} key={s.title}>
          <Box sx={{ p: 3, border: '1px solid #eee', borderRadius: 2, height: '100%' }}>
            <Box sx={{ mb: 1 }}>{s.icon}</Box>
            <Typography variant="h6">{s.title}</Typography>
            <Typography variant="body2" color="text.secondary">{s.text}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
